import { Radio } from "components/form_components/Inputs";
import { SupplierSelect } from "components/form_components/SupplierSelect";
import Divider from "components/ui/divider/Divider";
import RedactedWrapper from "lib/core_components/RedactedWrapper";
import { LeadFilters } from "../utils";
import { LeadFilterContentProps, StyledFilterContent } from "./utils";

const SME_OPTIONS = [
  { label: "Show all suppliers", value: "" },
  { label: "Show only SMEs", value: "true" },
  { label: "Hide SMEs", value: "false" },
];

function SuppliersFilterContent({ control }: LeadFilterContentProps) {
  const radioProps = {
    label: "SME Supplier?",
    name: "supplierSme" as keyof LeadFilters,
    options: SME_OPTIONS,
    optionType: "default" as const,
    direction: "vertical" as const,
    control,
  };

  return (
    <StyledFilterContent aria-label="Supplier filters">
      <SupplierSelect name="supplierGuids" label="Supplier Guids" control={control} />
      <Divider />
      <RedactedWrapper
        redactContent={<Radio {...radioProps} disabled />}
        requiredDataType="SUPPLIERS"
        contextSource="Supplier filter"
      >
        <Radio {...radioProps} />
      </RedactedWrapper>
    </StyledFilterContent>
  );
}

export default SuppliersFilterContent;
